export default {
  LOAD_ASSESSMENT (state, payload) {
    state.assessment = payload
  },
  LOAD_LEARNING_SPACES (state, payload) {
    state.learningSpaces = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/assessment/vuex/mutations.js